import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import cx from 'classnames';

import { usePopper } from "react-popper";

import { Portals } from 'constants/constants';
import { randomId } from 'utils/utils';
import UIState, { selectDropdown } from 'store/UIState';


import Scrollbars from 'components/Scrollbars';

const selector = createSelector(
  selectDropdown,
  (dropdown) => ({ dropdown })
);


const Dropdown = (props) => {
  let { target, arrow, children, className, showOverlay = true, placement = 'bottom-start' } = props;
  const { dropdown } = useSelector(selector);
  const dispatch = useDispatch();
  const [id, setId] = useState(randomId());
  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const [arrowElement, setArrowElement] = useState(null);
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement,
    modifiers: [
      { name: 'arrow', options: { element: arrowElement }},
      { name: 'offset', options: { offset: [0, 10] }},
      { name: 'preventOverflow', options: {  }},
    ],
  });

  const show = dropdown === id;

  const toggle = () => show
    ? dispatch(UIState.actions.hideDropdown())
    : dispatch(UIState.actions.showDropdown(id))
  
  const onTargetClick = (e) => {
    e?.stopPropagation?.();
    e?.preventDefault?.();
    toggle();
  }
  const onOverlayClick = (e) => {
    e?.stopPropagation?.();
    e?.preventDefault?.();
    dispatch(UIState.actions.hideDropdown())
  }

  const onDropdownClick = e => {
    e.preventDefault();
    toggle();
  }

  return (<>
    { target?.({ 
        onClick: onTargetClick,
        ref: setReferenceElement,
        style: { zIndex: show ? 499 : null } })}
    { show && 
    ReactDOM.createPortal(<>
        <div 
          ref={setPopperElement} 
          className={cx("g-dropdown", className)} 
          style={styles.popper} 
          onClick={onDropdownClick}
          {...attributes.popper}>
          { children }
          <div 
            ref={setArrowElement} 
            className="arrow" 
            style={styles.arrow} 
            {...attributes.arrow} />
        </div>
        {showOverlay && 
        <div className="g-dropdown-overlay" onClick={onOverlayClick} />}
    </>, document.getElementById(Portals.POPUP),)}
  </>);
}
export default Dropdown;
